import Immutable from 'seamless-immutable';
import ActionTypes from '../common/ActionTypes';

const DEFAULT_STATE = Immutable({
  card: null,
  loading: false,
  failed: false,
  clientSecret: null,
  paymentMethodId: null,
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.PREMIUM_CLIENT_SECRET:
      return state.setIn(['clientSecret'], action.clientSecret);
    case ActionTypes.PAYMENT_METHOD_ADDED:
      return state.setIn(['paymentMethodId'], action.data);
    case ActionTypes.USER_PAYMENT_CARD_UPDATED:
      return state.setIn(['card'], action.data);
    case ActionTypes.USER_PAYMENT_CARD_DELETED:
      return state.setIn(['card'], null);
    case ActionTypes.USER_PAYMENT_CARD_LOADING:
      return state.setIn(['loading'], action.loading);
    case ActionTypes.USER_PAYMENT_CARD_FAILED:
      return state.setIn(['failed'], action.failed);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentCards.js